<ng-container thr-parent-form [ngSwitch]="docType">
    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.DNI">
        <mat-label>{{ 'form.document-types.DN' | translate }}</mat-label>
        <input
            [name]="prefix + name"
            matInput
            [placeholder]="'form.hints.dni' | translate"
            required
            minlength="9"
            maxlength="10"
            dni
            [disabled]="isDisabled"
            [(ngModel)]="value"
            (ngModelChange)="onValueChange()"
            #documentCtrl="ngModel"
        />
        <mat-error *ngIf="documentCtrl.hasError('dni') && !documentCtrl.hasError('required')">
            {{ 'form.validation.invalid.document' | translate }}
        </mat-error>
        <mat-error *ngIf="documentCtrl.hasError('required')">
            {{ 'form.validation.required' | translate }}
        </mat-error>
    </mat-form-field>
    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.NIF">
        <mat-label>{{ 'form.document-types.NF' | translate }}</mat-label>
        <input
            [name]="prefix + name"
            matInput
            [placeholder]="'form.hints.nif' | translate"
            required
            minlength="9"
            maxlength="15"
            nif
            [disabled]="isDisabled"
            [(ngModel)]="value"
            (ngModelChange)="onValueChange()"
            #documentCtrl="ngModel"
        />
        <mat-error *ngIf="documentCtrl.hasError('nif') && !documentCtrl.hasError('required')">
            {{ 'form.validation.invalid.document' | translate }}
        </mat-error>
        <mat-error *ngIf="documentCtrl.hasError('required')">
            {{ 'form.validation.required' | translate }}
        </mat-error>
    </mat-form-field>
    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.CIF">
        <mat-label>{{ 'form.document-types.CI' | translate }}</mat-label>
        <input
            [name]="prefix + name"
            matInput
            [placeholder]="'form.hints.cif' | translate"
            required
            minlength="9"
            maxlength="15"
            cif
            [disabled]="isDisabled"
            [(ngModel)]="value"
            (ngModelChange)="onValueChange()"
            #documentCtrl="ngModel"
        />
        <mat-error *ngIf="documentCtrl.hasError('cif') && !documentCtrl.hasError('required')">
            {{ 'form.validation.invalid.document' | translate }}
        </mat-error>
        <mat-error *ngIf="documentCtrl.hasError('required')">
            {{ 'form.validation.required' | translate }}
        </mat-error>
    </mat-form-field>
    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.NIE">
        <mat-label>{{ 'form.document-types.NR' | translate }}</mat-label>
        <input
            [name]="prefix + name"
            matInput
            [placeholder]="'form.hints.nie' | translate"
            required
            minlength="9"
            maxlength="15"
            nie
            [disabled]="isDisabled"
            [(ngModel)]="value"
            (ngModelChange)="onValueChange()"
            #documentCtrl="ngModel"
        />
        <mat-error *ngIf="documentCtrl.hasError('nie') && !documentCtrl.hasError('required')">
            {{ 'form.validation.invalid.document' | translate }}
        </mat-error>
        <mat-error *ngIf="documentCtrl.hasError('required')">
            {{ 'form.validation.required' | translate }}
        </mat-error>
    </mat-form-field>
    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.NIE_NOT_RESIDENT">
        <mat-label>{{ 'form.document-types.NN' | translate }}</mat-label>
        <input
            [name]="prefix + name"
            matInput
            [placeholder]="'form.hints.nie' | translate"
            required
            maxlength="15"
            nie
            [disabled]="isDisabled"
            [(ngModel)]="value"
            (ngModelChange)="onValueChange()"
            #documentCtrl="ngModel"
        />
        <mat-error *ngIf="documentCtrl.hasError('nie') && !documentCtrl.hasError('required')">
            {{ 'form.validation.invalid.document' | translate }}
        </mat-error>
        <mat-error *ngIf="documentCtrl.hasError('required')">
            {{ 'form.validation.required' | translate }}
        </mat-error>
    </mat-form-field>
    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.PASSPORT">
        <input
            [name]="prefix + name"
            matInput
            [placeholder]="'form.document-types.PN' | translate"
            required
            maxlength="15"
            [disabled]="isDisabled"
            [(ngModel)]="value"
            (ngModelChange)="onValueChange()"
            #documentCtrl="ngModel"
        />
        <mat-error *ngIf="documentCtrl.hasError('required')">
            {{ 'form.validation.required' | translate }}
        </mat-error>
    </mat-form-field>
    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.PASSPORT_LATIN">
        <input
            [name]="prefix + name"
            matInput
            [placeholder]="'form.document-types.PL' | translate"
            required
            maxlength="15"
            [disabled]="isDisabled"
            [(ngModel)]="value"
            (ngModelChange)="onValueChange()"
            #documentCtrl="ngModel"
        />
        <mat-error *ngIf="documentCtrl.hasError('required')">
            {{ 'form.validation.required' | translate }}
        </mat-error>
    </mat-form-field>
    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.PERMISSION">
        <input
            [name]="prefix + name"
            matInput
            [placeholder]="'form.document-types.PR' | translate"
            required
            maxlength="15"
            [disabled]="isDisabled"
            [(ngModel)]="value"
            (ngModelChange)="onValueChange()"
            #documentCtrl="ngModel"
        />
        <mat-error *ngIf="documentCtrl.hasError('required')">
            {{ 'form.validation.required' | translate }}
        </mat-error>
    </mat-form-field>
    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.IDENTIFICATION_CARD_NOT_RESIDENT">
        <input
            [name]="prefix + name"
            matInput
            [placeholder]="'form.document-types.TR' | translate"
            required
            maxlength="15"
            [disabled]="isDisabled"
            [(ngModel)]="value"
            (ngModelChange)="onValueChange()"
            #documentCtrl="ngModel"
        />
        <mat-error *ngIf="documentCtrl.hasError('required')">
            {{ 'form.validation.required' | translate }}
        </mat-error>
    </mat-form-field>
    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchDefault>
        <input
            [name]="prefix + name"
            matInput
            [placeholder]="'form.document-types.DI' | translate"
            required
            maxlength="15"
            [disabled]="isDisabled"
            [(ngModel)]="value"
            (ngModelChange)="onValueChange()"
            #documentCtrl="ngModel"
        />
        <mat-error *ngIf="documentCtrl.hasError('required')">
            {{ 'form.validation.required' | translate }}
        </mat-error>
    </mat-form-field>
</ng-container>
